import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tw-mb-4 tw-rounded-xl tw-border tw-border-rose-200/70 tw-bg-rose-50 tw-px-4 tw-py-3 tw-text-sm tw-text-rose-900"
}
const _hoisted_2 = { class: "tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-4" }
const _hoisted_3 = { class: "tw-mt-5 tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-4" }
const _hoisted_4 = { class: "tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-p-4" }
const _hoisted_5 = { class: "tw-mt-3 tw-grid tw-grid-cols-1 sm:tw-grid-cols-3 tw-gap-3" }
const _hoisted_6 = { class: "tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-p-4" }
const _hoisted_7 = { class: "tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-2" }
const _hoisted_8 = { class: "tw-inline-flex tw-items-center tw-gap-2 tw-text-sm tw-text-slate-700" }
const _hoisted_9 = {
  key: 0,
  class: "tw-mt-3 tw-grid tw-grid-cols-1 sm:tw-grid-cols-3 tw-gap-3"
}
const _hoisted_10 = {
  key: 1,
  class: "tw-mt-3 tw-text-sm tw-text-slate-600"
}
const _hoisted_11 = {
  key: 1,
  class: "tw-mt-4 tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-slate-600"
}
const _hoisted_12 = { class: "tw-mt-5 tw-flex tw-items-center tw-justify-end tw-gap-2 tw-border-t tw-border-slate-200/70 tw-pt-4" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputField = _resolveComponent("InputField")!
  const _component_GoogleAddressInput = _resolveComponent("GoogleAddressInput")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    isOpen: _ctx.isOpen,
    "onUpdate:isOpen": _cache[14] || (_cache[14] = ($event: any) => (_ctx.$emit('update:isOpen', $event))),
    modalId: "create-customer-modal",
    title: `New ${_ctx.showingCustomerType === 'billing' ? 'Customer' : 'Receiver'}`,
    subtitle: "Create a new record and optionally save addresses.",
    maxWidth: "7xl",
    onClose: _ctx.onClose
  }, {
    content: _withCtx(({ close }) => [
      (_ctx.loadFormError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.loadFormError), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_InputField, {
          id: "customer_name",
          label: "* Customer Name (required)",
          modelValue: _ctx.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
          class: "tw-w-full"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_InputField, {
          id: "customer_email",
          label: "Customer Email (recommended)",
          modelValue: _ctx.email,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email) = $event)),
          class: "tw-w-full"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "tw-text-sm tw-font-semibold tw-text-slate-900" }, "Drop-off address", -1)),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_GoogleAddressInput, {
              id: "receiver_street",
              label: "Street Address",
              modelValue: _ctx.receiverAddress.streetAddress,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.receiverAddress.streetAddress) = $event)),
              class: "sm:tw-col-span-2",
              onAddressSelected: _ctx.handleReceiverAddress
            }, null, 8, ["modelValue", "onAddressSelected"]),
            _createVNode(_component_InputField, {
              id: "receiver_suite",
              label: "Suite #",
              modelValue: _ctx.receiverAddress.suite,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.receiverAddress.suite) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_InputField, {
              id: "receiver_city",
              label: "City",
              modelValue: _ctx.receiverAddress.city,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.receiverAddress.city) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_InputField, {
              id: "receiver_state",
              label: "State",
              modelValue: _ctx.receiverAddress.state,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.receiverAddress.state) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_InputField, {
              id: "receiver_zip",
              label: "Zip",
              modelValue: _ctx.receiverAddress.zipCode,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.receiverAddress.zipCode) = $event))
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _cache[17] || (_cache[17] = _createElementVNode("div", { class: "tw-text-sm tw-font-semibold tw-text-slate-900" }, "Billing address", -1)),
            _createElementVNode("label", _hoisted_8, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.useDropOffAddress) = $event)),
                class: "tw-h-4 tw-w-4 tw-rounded tw-border-slate-300"
              }, null, 512), [
                [_vModelCheckbox, _ctx.useDropOffAddress]
              ]),
              _cache[16] || (_cache[16] = _createTextVNode(" Same as drop-off ", -1))
            ])
          ]),
          (!_ctx.useDropOffAddress)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_component_GoogleAddressInput, {
                  id: "billing_street",
                  label: "Street Address",
                  modelValue: _ctx.billingAddress.streetAddress,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.billingAddress.streetAddress) = $event)),
                  class: "sm:tw-col-span-2",
                  onAddressSelected: _ctx.handleBillingAddress
                }, null, 8, ["modelValue", "onAddressSelected"]),
                _createVNode(_component_InputField, {
                  id: "billing_suite",
                  label: "Suite #",
                  modelValue: _ctx.billingAddress.suite,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.billingAddress.suite) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_InputField, {
                  id: "billing_city",
                  label: "City",
                  modelValue: _ctx.billingAddress.city,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.billingAddress.city) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_InputField, {
                  id: "billing_state",
                  label: "State",
                  modelValue: _ctx.billingAddress.state,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.billingAddress.state) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_InputField, {
                  id: "billing_zip",
                  label: "Zip",
                  modelValue: _ctx.billingAddress.zipCode,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.billingAddress.zipCode) = $event))
                }, null, 8, ["modelValue"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, " Billing address will be copied from drop-off. "))
        ])
      ]),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(_component_font_awesome_icon, {
              icon: "circle-notch",
              spin: "",
              class: "tw-h-4 tw-w-4 tw-text-slate-500"
            }),
            _cache[18] || (_cache[18] = _createTextVNode(" Saving… ", -1))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("button", {
          type: "button",
          class: "tw-inline-flex tw-items-center tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-slate-700 hover:tw-bg-slate-50",
          onClick: close
        }, " Cancel ", 8, _hoisted_13),
        _createElementVNode("button", {
          type: "button",
          class: "tw-inline-flex tw-items-center tw-rounded-xl tw-border tw-border-transparent tw-bg-slate-900 tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-white hover:tw-bg-slate-800 disabled:tw-opacity-60 disabled:tw-cursor-not-allowed",
          onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.createNewCustomer && _ctx.createNewCustomer(...args))),
          disabled: !_ctx.isFormComplete || _ctx.loading
        }, " Add New ", 8, _hoisted_14)
      ])
    ]),
    _: 1
  }, 8, ["isOpen", "title", "onClose"]))
}